export enum Stage {
    VehicleInfo,
    RequiredWork,
    FindAGarage,
    TimeAndDate,
    DriverDetails,
    Summary,
}

export const StageI18nKey = {
  [Stage.VehicleInfo]: "stages_vehicle_info",
  [Stage.RequiredWork]: "stages_required_work",
  [Stage.FindAGarage]: "stages_find_a_garage",
  [Stage.TimeAndDate]: "stages_time_and_date",
  [Stage.DriverDetails]: "stages_driver_details",
  [Stage.Summary]: "stages_summary",
} as const satisfies Record<Stage, string>;

export const getStageKey = (stage: Stage): string => StageI18nKey[stage];
